var map = {
	"./images/aboutus/AboutUs_BG-02 2.png": 433,
	"./images/aboutus/About_BG-01.png": 434,
	"./images/aboutus/About_BG-02.png": 435,
	"./images/aboutus/About_BG-03.png": 436,
	"./images/aboutus/About_BG-04.png": 437,
	"./images/aboutus/About_BG-05.png": 438,
	"./images/aboutus/About_BG-06.png": 439,
	"./images/aboutus/About_BG-06.svg": 440,
	"./images/aboutus/About_BG-07.png": 441,
	"./images/aboutus/About_BG-08.png": 442,
	"./images/aboutus/About_BG-08.svg": 443,
	"./images/aboutus/About_BG-09.svg": 444,
	"./images/aboutus/About_BG-Shapes-01.png": 445,
	"./images/aboutus/About_BG-Shapes-02 1.png": 446,
	"./images/aboutus/About_BG-Shapes-02 2.png": 447,
	"./images/aboutus/About_BG-Shapes-02.png": 448,
	"./images/aboutus/About_IMG-Accoutability.png": 192,
	"./images/aboutus/About_IMG-Diligence.png": 197,
	"./images/aboutus/About_IMG-Equality.png": 196,
	"./images/aboutus/About_IMG-Guidance.png": 199,
	"./images/aboutus/About_IMG-Integrity.png": 449,
	"./images/aboutus/About_IMG-People.png": 450,
	"./images/aboutus/About_IMG-Quality.png": 194,
	"./images/aboutus/About_IMG-Timing.png": 451,
	"./images/aboutus/About_IMG-Wisdom.png": 195,
	"./images/aboutus/About_Icon-AccurateCost.png": 185,
	"./images/aboutus/About_Icon-AdvancedScheduling.png": 187,
	"./images/aboutus/About_Icon-LowOver.png": 186,
	"./images/aboutus/About_Icon-TimelyClose.png": 188,
	"./images/aboutus/About_Logo-02.png": 189,
	"./images/aboutus/BG-ABOUT-01.png": 452,
	"./images/aboutus/Group 107.png": 453,
	"./images/aboutus/Group 212.jpg": 454,
	"./images/aboutus/Group 212.png": 455,
	"./images/aboutus/Group 555.png": 456,
	"./images/aboutus/Mask Group 67.png": 191,
	"./images/aboutus/Mask Group 69.jpg": 193,
	"./images/aboutus/Mask Group 70.png": 198,
	"./images/aboutus/Mask group.svg": 457,
	"./images/aboutus/PAGE-6.jpg": 458,
	"./images/aboutus/PAGE-6.zip": 459,
	"./images/aboutus/PAGE-6@2x.jpg": 460,
	"./images/awards/awards-bg-1.png": 461,
	"./images/awards/awards-bg-1.svg": 462,
	"./images/awards/awards-bg.png": 463,
	"./images/awards/jkr.png": 98,
	"./images/awardsandachievements/Awards_BG-01.png": 464,
	"./images/awardsandachievements/Awards_BG-02.png": 465,
	"./images/awardsandachievements/Awards_BG-021.png": 466,
	"./images/awardsandachievements/Awards_BG-03.png": 467,
	"./images/awardsandachievements/Awards_IMG-Testimonial-01.png": 468,
	"./images/awardsandachievements/Awards_IMG-Winner-01.png": 469,
	"./images/awardsandachievements/Awards_IMG-Winner-02.png": 470,
	"./images/awardsandachievements/Awards_Shapes-01.png": 471,
	"./images/awardsandachievements/Awards_Shapes-02.png": 472,
	"./images/awardsandachievements/Awards_Shapes-03.png": 217,
	"./images/awardsandachievements/hero-bg.png": 216,
	"./images/awardsandachievements/testimonials-bg.png": 473,
	"./images/building/Group 878.jpg": 292,
	"./images/building/Group 878@2x.jpg": 293,
	"./images/building/Group 879.jpg": 294,
	"./images/building/Group 879@2x.jpg": 295,
	"./images/building/Image 97.png": 296,
	"./images/building/Image 97@2x.png": 297,
	"./images/building/carousel/mahligai/1.png": 298,
	"./images/building/carousel/mahligai/2.png": 299,
	"./images/building/carousel/mahligai/3.png": 300,
	"./images/building/carousel/mahligai/4.png": 301,
	"./images/building/carousel/tropicana/1.png": 302,
	"./images/building/left.png": 124,
	"./images/building/mahligai-middle.png": 303,
	"./images/building/mahligai.png": 304,
	"./images/building/natl-camp.png": 305,
	"./images/building/shape-right.png": 306,
	"./images/building/svg-1.svg": 125,
	"./images/building/svg-10.svg": 126,
	"./images/building/svg-11.svg": 307,
	"./images/building/svg-12.svg": 127,
	"./images/building/svg-13.svg": 308,
	"./images/building/svg-14.svg": 128,
	"./images/building/svg-15.svg": 129,
	"./images/building/svg-16.svg": 130,
	"./images/building/svg-17.svg": 131,
	"./images/building/svg-2.svg": 132,
	"./images/building/svg-3.svg": 77,
	"./images/building/svg-4.svg": 78,
	"./images/building/svg-5.svg": 133,
	"./images/building/svg-6.svg": 134,
	"./images/building/svg-7.svg": 135,
	"./images/building/svg-8.svg": 136,
	"./images/building/svg-9.svg": 137,
	"./images/building/tropicana-cenang.png": 309,
	"./images/building/tropicana-middle-1.png": 138,
	"./images/building/tropicana-middle-2.png": 139,
	"./images/building/tropicana-middle.png": 310,
	"./images/career/Group 851.png": 474,
	"./images/civilengineering/CivilEng_BG-01-1.png": 475,
	"./images/civilengineering/CivilEng_BG-01-2.png": 476,
	"./images/civilengineering/CivilEng_BG-01-3.png": 477,
	"./images/civilengineering/CivilEng_BG-01-4.png": 478,
	"./images/civilengineering/CivilEng_BG-01-5.png": 479,
	"./images/civilengineering/CivilEng_BG-01.png": 480,
	"./images/civilengineering/CivilEng_IMG-Earthwork.png": 311,
	"./images/civilengineering/CivilEng_IMG-PipeJacking-02.png": 312,
	"./images/civilengineering/CivilEng_IMG-PipeJacking.png": 313,
	"./images/civilengineering/CivilEng_IMG-Seremban.png": 314,
	"./images/civilengineering/CivilEng_IMG-Sungai.png": 315,
	"./images/civilengineering/CivilEng_IMG-TNB.png": 316,
	"./images/civilengineering/CivilEng_Icon-01.png": 79,
	"./images/civilengineering/CivilEng_Icon-02.png": 80,
	"./images/civilengineering/CivilEng_Icon-03.png": 317,
	"./images/civilengineering/CivilEng_Icon-04.png": 318,
	"./images/civilengineering/CivilEng_Icon-05.png": 319,
	"./images/civilengineering/CivilEng_Icon-06.png": 320,
	"./images/civilengineering/CivilEng_Shapes-01.png": 481,
	"./images/civilengineering/CivilEng_Shapes-02.png": 482,
	"./images/civilengineering/CivilEng_Shapes-03.png": 483,
	"./images/civilengineering/CivilEng_Shapes-04.png": 484,
	"./images/civilengineering/CivilEng_Shapes-05.png": 485,
	"./images/civilengineering/PropertyDev_IMG-NationalCamp.png": 486,
	"./images/civilinfrastructure/Group 805.jpg": 487,
	"./images/civilinfrastructure/Group 805@2x.jpg": 488,
	"./images/civilinfrastructure/Mask Group 4.png": 321,
	"./images/civilinfrastructure/Mask Group 4@2x.png": 489,
	"./images/civilinfrastructure/Mask Group 5.png": 322,
	"./images/civilinfrastructure/Mask Group 5@2x.png": 490,
	"./images/civilinfrastructure/Mask Group 6.png": 323,
	"./images/civilinfrastructure/Mask Group 6@2x.png": 491,
	"./images/civilinfrastructure/Rectangle 151.png": 324,
	"./images/civilinfrastructure/Rectangle 151@2x.png": 492,
	"./images/civilinfrastructure/bg-bottom.png": 325,
	"./images/civilinfrastructure/bg-mid.png": 493,
	"./images/civilinfrastructure/bg-mid.svg": 326,
	"./images/civilinfrastructure/right-1.png": 494,
	"./images/civilinfrastructure/right-1.svg": 327,
	"./images/civilinfrastructure/right-2.png": 328,
	"./images/civilinfrastructure/right-3.png": 495,
	"./images/civilinfrastructure/right-3.svg": 329,
	"./images/civilinfrastructure/right-4.png": 330,
	"./images/civilinfrastructure/right-5.png": 496,
	"./images/civilinfrastructure/right-5.svg": 331,
	"./images/civilinfrastructure/right-6.png": 332,
	"./images/construction/related/mahligai.png": 497,
	"./images/construction/related/natl-camp.png": 498,
	"./images/construction/related/tropicana-cenang.png": 499,
	"./images/contactus/Contact_BG-01.png": 500,
	"./images/contactus/Contact_BG-02.png": 501,
	"./images/contactus/Contact_Button-01.png": 502,
	"./images/contactus/Contact_Icon-01.png": 503,
	"./images/contactus/Contact_Icon-02.png": 504,
	"./images/contactus/Contact_Icon-03.png": 505,
	"./images/contactus/Contact_Shapes-01.png": 506,
	"./images/contactus/Icon-1.svg": 333,
	"./images/contactus/Icon-2.svg": 334,
	"./images/contactus/Icon-3.svg": 335,
	"./images/contactus/Tem_Prompt-Modal-BG.png": 49,
	"./images/contactus/Tem_Prompt-Modal.png": 507,
	"./images/contactus/Tem_Prompt-Modal_Button.png": 50,
	"./images/contactus/form-image.png": 336,
	"./images/contactus/icon1.svg": 508,
	"./images/contactus/icon2.svg": 509,
	"./images/contactus/icon3.svg": 510,
	"./images/footer/Button-FB.svg": 96,
	"./images/footer/Button-IG.svg": 97,
	"./images/home/About_BG-07.png": 176,
	"./images/home/About_BG-08.png": 511,
	"./images/home/About_BG-09.svg": 512,
	"./images/home/About_BG-10.svg": 513,
	"./images/home/Group 49.jpg": 514,
	"./images/home/Group 49.png": 182,
	"./images/home/Group 833.png": 65,
	"./images/home/Group 955.svg": 515,
	"./images/home/Home_BG-01.png": 516,
	"./images/home/Home_BG-02.png": 517,
	"./images/home/Home_BG-03.png": 518,
	"./images/home/Home_BG-04.png": 184,
	"./images/home/Home_IMG-01.png": 519,
	"./images/home/Home_IMG-02.png": 520,
	"./images/home/Home_IMG-03.png": 521,
	"./images/home/Home_IMG-Civil-02.png": 522,
	"./images/home/Home_IMG-Civil.png": 523,
	"./images/home/Home_IMG-Property.png": 524,
	"./images/home/Home_Logo-Mahligai.png": 183,
	"./images/home/Mahligai_Aerial View@2x.png": 175,
	"./images/home/Mask Group 65.jpg": 95,
	"./images/home/Mask group.svg": 525,
	"./images/home/Page03-IMG1.png": 178,
	"./images/home/Page03-IMG2.png": 179,
	"./images/home/Page03-IMG3.png": 177,
	"./images/home/Page1_BG.png": 174,
	"./images/home/Page3_BG.jpg": 180,
	"./images/home/Page3_BG.png": 526,
	"./images/landacquisition/Group 851.png": 527,
	"./images/landacquisition/Group 851.zip": 528,
	"./images/landacquisition/Group 851@2x.png": 529,
	"./images/landacquisition/form-vector-1.png": 530,
	"./images/landacquisition/form-vector-2.png": 531,
	"./images/landacquisition/form-vector-3.png": 532,
	"./images/landacquisition/form-vector/1.svg": 533,
	"./images/landacquisition/form-vector/2.svg": 534,
	"./images/landacquisition/form-vector/3.svg": 535,
	"./images/landacquisition/form-vector/4.svg": 536,
	"./images/landacquisition/form-vector/5.svg": 537,
	"./images/landacquisition/form-vector/6.svg": 538,
	"./images/landacquisition/svg-1.svg": 99,
	"./images/landacquisition/svg-2.svg": 100,
	"./images/landacquisition/svg-3.svg": 101,
	"./images/landacquisition/svg-4.svg": 102,
	"./images/landacquisition/svg-5.svg": 103,
	"./images/landacquisition/svg-6.svg": 104,
	"./images/landacquisition/vectors/6-01.svg": 539,
	"./images/landacquisition/vectors/6-02.svg": 540,
	"./images/landacquisition/vectors/6-03.svg": 541,
	"./images/landacquisition/vectors/6-04.svg": 542,
	"./images/landacquisition/vectors/6-05.svg": 543,
	"./images/landacquisition/vectors/6-06.svg": 544,
	"./images/landacquisition/vectors/6-07.svg": 545,
	"./images/landacquisition/vectors/6-08.svg": 546,
	"./images/landacquisition/vectors/6-09.svg": 547,
	"./images/landacquisition/vectors/6-10.svg": 548,
	"./images/leaders/Image 78.png": 549,
	"./images/leaders/Image 78@2x.png": 550,
	"./images/leaders/Leaders_BG-01.png": 551,
	"./images/leaders/Leaders_Button-01.png": 552,
	"./images/leaders/Leaders_Button-02.png": 553,
	"./images/leaders/Leaders_Button-03.png": 554,
	"./images/leaders/Leaders_IMG-ChanYoon.png": 555,
	"./images/leaders/Leaders_IMG-Crystal.png": 337,
	"./images/leaders/Leaders_IMG-Jeremiah.png": 556,
	"./images/leaders/Leaders_IMG-Pathooraman.png": 338,
	"./images/leaders/Leaders_IMG-TanChien-02.png": 557,
	"./images/leaders/Leaders_IMG-TanChien.png": 558,
	"./images/leaders/Leaders_IMG-YBHG.png": 559,
	"./images/leaders/Leaders_IMG-YMRaja-02.png": 339,
	"./images/leaders/Leaders_IMG-YMRaja.png": 340,
	"./images/leaders/Leaders_Shapes-01.png": 560,
	"./images/licensesandregistrations/Licenses_BG-01.png": 219,
	"./images/licensesandregistrations/Licenses_BG-02.png": 220,
	"./images/licensesandregistrations/Licenses_BG-03.png": 221,
	"./images/licensesandregistrations/Licenses_Button-01.png": 222,
	"./images/licensesandregistrations/Licenses_Button-02.png": 223,
	"./images/licensesandregistrations/Licenses_Button-03.png": 224,
	"./images/licensesandregistrations/Licenses_Button-04.png": 225,
	"./images/licensesandregistrations/Licenses_IMG-License-01.png": 226,
	"./images/licensesandregistrations/Licenses_IMG-License-02.png": 227,
	"./images/licensesandregistrations/Licenses_IMG-License-03.png": 228,
	"./images/licensesandregistrations/Licenses_IMG-License-04.png": 229,
	"./images/licensesandregistrations/Licenses_IMG-License-05.png": 230,
	"./images/licensesandregistrations/Licenses_IMG-License-06.png": 231,
	"./images/licensesandregistrations/Licenses_IMG-QA-01.png": 232,
	"./images/licensesandregistrations/Licenses_IMG-QA-02.png": 233,
	"./images/licensesandregistrations/Licenses_IMG-QA-03.png": 234,
	"./images/licensesandregistrations/Licenses_IMG-QA-04.png": 235,
	"./images/licensesandregistrations/Licenses_IMG-QA-05.png": 236,
	"./images/licensesandregistrations/Licenses_IMG-QA-06.png": 237,
	"./images/licensesandregistrations/Licenses_IMG-QA-07.png": 238,
	"./images/licensesandregistrations/Licenses_Shapes-01.png": 239,
	"./images/licensesandregistrations/Licenses_Shapes-02.png": 240,
	"./images/licensesandregistrations/Licenses_Shapes-03.png": 241,
	"./images/licensesandregistrations/bakti-suci.png": 242,
	"./images/licensesandregistrations/bpkud.png": 243,
	"./images/licensesandregistrations/cidb-blue.png": 244,
	"./images/licensesandregistrations/cidb.png": 245,
	"./images/licensesandregistrations/hero-bg.png": 105,
	"./images/licensesandregistrations/iso.png": 246,
	"./images/licensesandregistrations/jccd.png": 247,
	"./images/licensesandregistrations/license-bottom-vector-1.png": 248,
	"./images/licensesandregistrations/license-bottom-vector-2.png": 249,
	"./images/licensesandregistrations/license-bottom-vector.png": 106,
	"./images/licensesandregistrations/licenses-bg-after.png": 250,
	"./images/licensesandregistrations/licenses-bg-before.png": 251,
	"./images/licensesandregistrations/licenses-bg.png": 252,
	"./images/licensesandregistrations/span.png": 253,
	"./images/mobile/Temokin_MobileVer_Icon-01.png": 561,
	"./images/mobile/aboutus/AboutUs_BG-01.png": 562,
	"./images/mobile/aboutus/AboutUs_BG-02.png": 563,
	"./images/mobile/aboutus/AboutUs_BG-03.png": 564,
	"./images/mobile/aboutus/AboutUs_BG-04.png": 565,
	"./images/mobile/awardsandachievements/Awards_BG-01.png": 566,
	"./images/mobile/awardsandachievements/Awards_BG-02.png": 567,
	"./images/mobile/awardsandachievements/Awards_BG-03.png": 568,
	"./images/mobile/awardsandachievements/Awards_BG-Shape-01.png": 569,
	"./images/mobile/awardsandachievements/Awards_BG-Shape-02.png": 570,
	"./images/mobile/awardsandachievements/Awards_BG-Shape-03.png": 571,
	"./images/mobile/awardsandachievements/Awards_BG-Shape-04.png": 572,
	"./images/mobile/awardsandachievements/Awards_BG-Shape-05.png": 573,
	"./images/mobile/awardsandachievements/Awards_BG-Shape-06.png": 574,
	"./images/mobile/civilengineering/CivilEng_BG-01.png": 575,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-01.png": 576,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-02.png": 577,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-03.png": 578,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-04.png": 579,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-05.png": 580,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-06.png": 581,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-07.png": 582,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-08.png": 583,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-09.png": 584,
	"./images/mobile/civilengineering/CivilEng_BG-Shape-10.png": 585,
	"./images/mobile/home/Group 838@3x.png": 173,
	"./images/mobile/home/Home_BG-01.png": 586,
	"./images/mobile/home/Home_BG-02.png": 587,
	"./images/mobile/home/Home_BG-03.png": 588,
	"./images/mobile/home/Obj_Arrow-01.png": 589,
	"./images/mobile/home/Obj_Arrow-02.png": 590,
	"./images/mobile/home/Page3_BG.jpg": 591,
	"./images/mobile/home/Page3_BG.png": 592,
	"./images/mobile/home/Page3_BG2.png": 593,
	"./images/mobile/home/Page4_BG.png": 594,
	"./images/mobile/home/close@3x.png": 595,
	"./images/mobile/home/down-chevron@3x.png": 596,
	"./images/mobile/home/up-chevron@3x.png": 597,
	"./images/mobile/licenses/Licenses_BG-01.png": 598,
	"./images/mobile/licenses/Licenses_BG-02.png": 599,
	"./images/mobile/licenses/Licenses_BG-03.png": 600,
	"./images/mobile/licenses/Licenses_BG-Shape-01.png": 601,
	"./images/mobile/licenses/Licenses_BG-Shape-02.png": 602,
	"./images/mobile/licenses/Licenses_BG-Shape-03.png": 603,
	"./images/mobile/licenses/Licenses_BG-Shape-04.png": 604,
	"./images/mobile/licenses/Licenses_BG-Shape-05.png": 605,
	"./images/otherbusinessventures/hero-bg.png": 606,
	"./images/privacypolicy/svg-1.svg": 341,
	"./images/privacypolicy/svg-2.svg": 342,
	"./images/privacypolicy/svg-3.svg": 343,
	"./images/privacypolicy/svg-4.svg": 140,
	"./images/privacypolicy/svg-5.svg": 607,
	"./images/privacypolicy/svg-6.svg": 608,
	"./images/privacypolicy/svg-7.svg": 344,
	"./images/projects/CivilEng_BG-01.png": 609,
	"./images/projects/CivilEng_IMG-Earthworks.png": 345,
	"./images/projects/CivilEng_IMG-PipeJacking-02.png": 346,
	"./images/projects/CivilEng_IMG-PipeJacking.png": 347,
	"./images/projects/CivilEng_IMG-Seremban.png": 348,
	"./images/projects/CivilEng_IMG-Sungai.png": 349,
	"./images/projects/CivilEng_IMG-TNB.png": 350,
	"./images/projects/CivilEng_Shapes-01.png": 610,
	"./images/projects/CivilEng_Shapes-02.png": 160,
	"./images/projects/CivilEng_Shapes-03.png": 161,
	"./images/projects/CivilEng_Shapes-04.png": 162,
	"./images/projects/CivilEng_Shapes-05.png": 163,
	"./images/projects/CivilEng_Shapes-06.png": 164,
	"./images/propertydevelopment/Mask group-1.svg": 254,
	"./images/propertydevelopment/Mask group.svg": 255,
	"./images/propertydevelopment/PropertyDev_BG-01.png": 256,
	"./images/propertydevelopment/PropertyDev_Button-01.png": 257,
	"./images/propertydevelopment/PropertyDev_Button-02.png": 258,
	"./images/propertydevelopment/PropertyDev_Button-03.png": 259,
	"./images/propertydevelopment/PropertyDev_IMG-Istana.png": 109,
	"./images/propertydevelopment/PropertyDev_IMG-Mahligai.png": 110,
	"./images/propertydevelopment/PropertyDev_IMG-NationalCamp.png": 111,
	"./images/propertydevelopment/PropertyDev_IMG-Tropicana.png": 112,
	"./images/propertydevelopment/PropertyDev_Shapes-01-1.png": 260,
	"./images/propertydevelopment/PropertyDev_Shapes-01-2.png": 261,
	"./images/propertydevelopment/PropertyDev_Shapes-01-3.png": 262,
	"./images/propertydevelopment/PropertyDev_Shapes-01-4.svg": 107,
	"./images/propertydevelopment/PropertyDev_Shapes-01-5.png": 263,
	"./images/propertydevelopment/PropertyDev_Shapes-01-5.svg": 108,
	"./images/propertydevelopment/PropertyDev_Shapes-01-6.svg": 264,
	"./images/propertydevelopment/PropertyDev_Shapes-01.png": 265,
	"./images/propertydevelopment/PropertyDev_Shapes-04.png": 266,
	"./images/propertydevelopment/awards/apa.png": 113,
	"./images/propertydevelopment/awards/appa.png": 114,
	"./images/propertydevelopment/awards/tdba.png": 115,
	"./images/propertydevelopment/carousel/diami.png": 267,
	"./images/propertydevelopment/carousel/diami/1.png": 268,
	"./images/propertydevelopment/carousel/diami/2.png": 269,
	"./images/propertydevelopment/carousel/diami/3.png": 270,
	"./images/propertydevelopment/carousel/diami/4.png": 271,
	"./images/propertydevelopment/carousel/mahligai.png": 272,
	"./images/propertydevelopment/carousel/mahligai/1.png": 273,
	"./images/propertydevelopment/carousel/mahligai/2.png": 274,
	"./images/propertydevelopment/carousel/mahligai/3.png": 275,
	"./images/propertydevelopment/carousel/mahligai/4.png": 276,
	"./images/propertydevelopment/carousel/tropicana.png": 277,
	"./images/propertydevelopment/carousel/tropicana/1.png": 278,
	"./images/propertydevelopment/carousel/tropicana/2.png": 279,
	"./images/propertydevelopment/carousel/tropicana/3.png": 280,
	"./images/propertydevelopment/carousel/tropicana/4.png": 281,
	"./images/propertydevelopment/diami-middle.png": 282,
	"./images/propertydevelopment/diami.png": 283,
	"./images/propertydevelopment/mahligai-middle.png": 284,
	"./images/propertydevelopment/mahligai.png": 285,
	"./images/propertydevelopment/related/diami.png": 286,
	"./images/propertydevelopment/related/mahligai.png": 287,
	"./images/propertydevelopment/related/tropicana-miyu.png": 288,
	"./images/propertydevelopment/svg-1.svg": 116,
	"./images/propertydevelopment/svg-2.svg": 117,
	"./images/propertydevelopment/svg-3.svg": 118,
	"./images/propertydevelopment/svg-4.svg": 119,
	"./images/propertydevelopment/svg-5.svg": 120,
	"./images/propertydevelopment/svg-6.svg": 121,
	"./images/propertydevelopment/svg-7.svg": 122,
	"./images/propertydevelopment/svg-8.svg": 123,
	"./images/propertydevelopment/tropicana-middle.png": 289,
	"./images/propertydevelopment/tropicana.png": 290,
	"./images/propertyprojects/PropertyDev_BG-01.png": 611,
	"./images/propertyprojects/PropertyDev_IMG-Istana.png": 612,
	"./images/propertyprojects/PropertyDev_IMG-Mahligai.png": 613,
	"./images/propertyprojects/PropertyDev_IMG-NationalCamp.png": 614,
	"./images/propertyprojects/PropertyDev_IMG-Tropicana.png": 615,
	"./images/propertyprojects/PropertyDev_Shapes-01.png": 71,
	"./images/propertyprojects/PropertyDev_Shapes-02.png": 616,
	"./images/propertyprojects/PropertyDev_Shapes-03.png": 617,
	"./images/propertyprojects/PropertyDev_Shapes-04.png": 165,
	"./images/propertyprojects/preview/mahligai/1.png": 618,
	"./images/propertyprojects/related/related.png": 619,
	"./images/propertyprojects/showcase-mahligai.png": 351,
	"./images/propertyprojects/vectors/Asset 1.svg": 620,
	"./images/teamleaders/Group 848.png": 213,
	"./images/teamleaders/Group 848@2x.png": 621,
	"./images/teamleaders/Group 849.png": 214,
	"./images/teamleaders/Group 849@2x.png": 622,
	"./images/teamleaders/Group 89.png": 215,
	"./images/teamleaders/Group 89@2x.png": 623,
	"./images/teamleaders/Image 78.png": 200,
	"./images/teamleaders/Image 78@2x.png": 624,
	"./images/teamleaders/Leaders_BG-01.png": 625,
	"./images/teamleaders/Leaders_BG-02.png": 626,
	"./images/teamleaders/Leaders_BG-03.png": 627,
	"./images/teamleaders/Leaders_Button-01.png": 628,
	"./images/teamleaders/Leaders_IMG-01.png": 629,
	"./images/teamleaders/Leaders_IMG-Leader-01A.png": 201,
	"./images/teamleaders/Leaders_IMG-Leader-01B.png": 202,
	"./images/teamleaders/Leaders_IMG-Leader-02A.png": 203,
	"./images/teamleaders/Leaders_IMG-Leader-02B.png": 204,
	"./images/teamleaders/Leaders_IMG-Leader-03A.png": 205,
	"./images/teamleaders/Leaders_IMG-Leader-03B.png": 206,
	"./images/teamleaders/Leaders_IMG-Leader-04A.png": 207,
	"./images/teamleaders/Leaders_IMG-Leader-04B.png": 208,
	"./images/teamleaders/Leaders_IMG-Leader-05A.png": 209,
	"./images/teamleaders/Leaders_IMG-Leader-05B.png": 210,
	"./images/teamleaders/Leaders_IMG-Leader-06A.png": 211,
	"./images/teamleaders/Leaders_IMG-Leader-06B.png": 212,
	"./images/teamleaders/Leaders_IMG-Leader-07A.png": 630,
	"./images/teamleaders/Leaders_IMG-Leader-07B.png": 631,
	"./images/teamleaders/Leaders_IMG-Leader-08A.png": 632,
	"./images/teamleaders/Leaders_IMG-Leader-08B.png": 633,
	"./images/teamleaders/Leaders_IMG-Leader-09A.png": 634,
	"./images/teamleaders/Leaders_IMG-Leader-09B.png": 635,
	"./images/teamleaders/Leaders_Shapes-01.png": 636,
	"./images/teamleaders/Leaders_Shapes-02.png": 637,
	"./images/teamleaders/Shape.png": 638,
	"./images/teamleaders/Shape@2x.png": 639,
	"./images/termsofservice/Contact_BG-02.png": 640,
	"./images/termsofservice/Image-85.png": 641,
	"./images/termsofservice/svg-01.svg": 352,
	"./images/termsofservice/svg-02.svg": 353,
	"./images/termsofservice/svg-03.svg": 642,
	"./images/termsofservice/svg-04.svg": 354,
	"./images/termsofservice/svg-05.svg": 355,
	"./images/termsofservice/svg-06.svg": 643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;